declare var swal: any;
import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SpinnerService } from '../../../../services/spinner.service';
import { AppData } from '../../../../models/appdata';
import { ApiResponseModel } from '../../../../models/api_response_model';
import { NgbModal, ModalDismissReasons, NgbActiveModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';

import { ActorIdentitiesController, ActorDocRequestByType, ActorDocControllerByType } from '../../../../models/actor/actor';
import { ActorService } from '../../../../services/actor.service';
import { DBOperation } from '../../../../enums/enum';
import { ActorIdentitiesPipe } from '../../../../pipes/actors/actorIdentity.pipes';
import * as alertFunctions from '../../../../../shared/data/sweet-alerts';
import { NgbActorDocsModal } from '../modals/actordocs/actordocs.modal';
import { routerTransition } from '../../../../animations/router.animations';
import { NGXToastrService } from '../../../../../shared/services/toastr.service';
import { DOCService } from '../../../../services/doc.service';
import { ActorIdentitiesRequest, ActorDocRequest, ActorDocController } from '../../../../models/actor/actor';
import { NgbIdentitiesinfoModal } from '../identitiesinfo/modals/identitiesinfo.modal';
@Component({
  selector: 'resumeupload',
  templateUrl: './resumeupload.component.html',
  styleUrls: ['./resumeupload.component.scss']
  , animations: [routerTransition()]
})

export class ResumeUploadComponent implements OnInit {
  
  @Input() ActorCode: number;
  @Input() ActorType: number;

  @Input() CanEdit: number;
  @Input() CanShow: number;
  @Input() CanShowRegistryView: number;

  SendActorDocRequest: ActorDocRequestByType;
  ActorDocController: ActorDocControllerByType[];
  FirstDoc: ActorDocControllerByType;
  public ApiResData: ApiResponseModel;
  public isRequesting: boolean = false;


  constructor(private router: Router, private docservice: DOCService,
    private route: ActivatedRoute, private loaderService: SpinnerService, private actorservice: ActorService, private actoridentitiespipe: ActorIdentitiesPipe,
    private modalService: NgbModal, private tosterservice: NGXToastrService) { }


  ngOnInit() {

    this.SendActorDocRequest = new ActorDocRequestByType();
    this.ActorDocController = new Array<ActorDocControllerByType>();
    this.SendActorDocRequest.ActorCode = this.ActorCode;
    this.SendActorDocRequest.DocType = "ResumeDoc";
      //AppData.Instance().UserLoginDetails.ActorCode;
    this.SendActorDocRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
 //   if (this.CanShow === 1 || this.CanShowRegistryView === 1)
    {
      this.GetActorDocument();
    }

  }

  GetActorDocument() {
    
    this.SendActorDocRequest.ConditionalOperator = 20;
    this.SendActorDocRequest.ActorDocCode = 5;
    this.docservice.GetActorDocByTypeController(this.SendActorDocRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
        
          this.ActorDocController = this.ApiResData.Result;

          if (this.ActorDocController.length > 0) //-- it has docs
          {
            //alert(this.ActorDocController.length);


          }
       
          this.FirstDoc = this.ActorDocController[0];
         // alert(this.FirstDoc.ActorDocCode);
          this.stopRefreshing();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


      (error) => {

        if (error == "401 - Unauthorized") {
          alertFunctions.AlertParamEr(error);
          this.stopRefreshing();



        }
        else {
          alertFunctions.AlertParamEr(error);
          this.stopRefreshing();
        }
      }


      );




  }





  openDocContent() {
   
    if (this.FirstDoc = null)
      return;
  
    //var ActorDocCode: number = this.FirstDoc.ActorDocCode;
    //alert(ActorDocCode);  
    if (this.ActorDocController[0].ActorDocCode > 0) {
      let options: NgbModalOptions = {
        size: 'lg'

      };
     // alert(this.ActorDocController[0].ActorDocCode);
      const modalRef = this.modalService.open(NgbActorDocsModal, options)//.result(result => { this.GetActorProfileController();});
      modalRef.componentInstance.ActorDocCode = this.ActorDocController[0].ActorDocCode;
      modalRef.componentInstance.CanEdit =1;
      modalRef.componentInstance.CanShow = 1;
      //modalRef.result.then(x => { this.GetActorIdentitiesController() })
    }
    else {
      alertFunctions.AlertParam('No permission to Upload Doc For this Record...!');
    }
  }


  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }

}
